export enum AccountType {
  GROUP = 'group',
  PRIMARY_ACCOUNT = 'primary',
}

export enum ReportSheetAccountType {
  DEBIT = 'Debit',
  CREDIT = 'Credit',
}

export interface Total {
  debitIn: number;
  debitOut: number;
  debitTo: number;
  creditIn: number;
  creditOut: number;
  creditTo: number;
}

export interface ReportSheetPrimariesWithStats {
  id: string;
  description: string;
  active: boolean;
  number: string;
  groupId: string;
  isClientAccount?: boolean;
  createdAt?: string;
  updatedAt?: string;
  deletedAt?: string;
  total: Total;
}

export interface ReportSheetGroupsWithStats {
  id: string;
  description: string;
  active: boolean;
  number: string;
  categoryId: string;
  createdAt?: string;
  updatedAt?: string;
  deletedAt?: string;
  total: Total;
  primaries?: ReportSheetPrimariesWithStats[];
}

export interface ReportSheetCategoriesWithTotal {
  id: string;
  name: string;
  active: boolean;
  number: string;
  type: ReportSheetAccountType;
  createdAt?: string;
  updatedAt?: string;
  deletedAt?: string;
  total: Total;
  groups?: ReportSheetGroupsWithStats[];
}

export type ReportSheet = ReportSheetCategoriesWithTotal;

export interface PspPartner {
  id: string;
  companyName: string;
  description?: string;
}

export interface PspAccount {
  id: string;
  description: string;
  pspPartnerId: string;
  pspPartner: PspPartner;
  account?: {
    clientName: string;
    id: string;
    fullNumber: string;
    description: string;
    overdraftEnabled: boolean;
  };
}

export interface Account {
  active: boolean;
  closed: boolean;
  debitBlock: boolean;
  creditBlock: boolean;
  description: string;
  iban: string;
  number: string;
  balance: number;
  fullNumber: string;
  groupId: string;
  primaryId: string;
  userId: string;
  organizationId: string;
  id: string;
  clientName: string;
  categoryId: string;
  accountType: AccountType;
  closedAt?: string;
  createdAt?: string;
  updatedAt?: string;
  deletedAt?: string;
  pspAccount?: PspAccount;
  overdraftEnabled?: boolean;
  revaluable: boolean;
}

export interface Category {
  active: boolean;
  id: string;
  isClientAccount: boolean;
  name: string;
  number: string;
  accountGroups?: Group[];
  type: string;
}

export interface Group {
  id: string;
  description: string;
  number: number;
  active?: boolean;
  categoryId?: string;
  category?: Category;
  isClientAccount?: boolean;
  primaryAccounts?: PrimaryAccount[];
}

export interface PrimaryAccount {
  description: string;
  number: string;
  active: boolean;
  groupId: string;
  group: Group;
  id: string;
}
